import React from 'react';
import { Plus, CreditCard, Building2 } from 'lucide-react';

const BillingHeader = ({ onNewInvoice, onNewExternalRevenue, onNewPayment }) => {
  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200">
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Financeiro</h2>
          <p className="text-gray-600">
            Gerencie receitas, despesas, contas a receber, contas a pagar, NFS-e, parceiros e relatórios
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={onNewInvoice}
            className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors flex items-center"
          >
            <Plus className="w-4 h-4 mr-2" />
            Nova Fatura
          </button>
          <button
            onClick={onNewExternalRevenue}
            className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors flex items-center"
          >
            <Building2 className="w-4 h-4 mr-2" />
            Nova Receita Externa
          </button>
          <button
            onClick={onNewPayment}
            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center"
          >
            <CreditCard className="w-4 h-4 mr-2" />
            Registrar Pagamento
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingHeader;
